import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.models');
import { ChangeDetectorRef, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Service } from "src/libs/portal/season/service";

const FOUR_POSTURE_CRITERIA: any = {
    alignment: 'four_class_contract',
    alignment_label: '4개 기준 적용',
    summary: '운영 자세 판정은 아래 4개 항목을 함께 확인합니다. 1·2·4번은 Pose 관절과 디텍터 좌표로 자동 판정하고, 3번은 단일 RGB 영상의 한계 때문에 촬영자가 직접 확인합니다.',
    decision_note: '학습모델 운영 시 5-head 결과를 우선 사용하고 불확실하거나 규칙과 충돌하면 정규화 좌표 규칙을 안전망으로 사용합니다.',
    items: [
        {
            key: 'arm_shoulder', number: 1, class_index: 1,
            title: '어깨 범위·기울어짐/틀어짐',
            description: '어깨가 디텍터의 촬영 범위를 벗어나거나, 좌우가 기울어지거나 틀어진 상태',
            coverage: 'core', coverage_label: '자동 판정',
            current_basis: '양쪽 어깨 좌표의 좌우 촬영 경계와 어깨 높이 차이÷어깨 너비 비율을 판정합니다.',
            gap: '팔 각도는 사용하지 않으며 2-D 영상만으로 실제 전방 회전을 확정하지 않습니다.',
            input_labels: ['Pose 양쪽 어깨', '촬영 좌우 경계', '기준 자세 통계']
        },
        {
            key: 'trunk_alignment', number: 2, class_index: 2,
            title: '상체 중심선 이탈',
            description: '디텍터 중심 대비 몸통 위치 또는 어깨-골반 중심 정렬이 정상 범위를 벗어난 상태',
            coverage: 'core', coverage_label: '자동 판정',
            current_basis: '어깨·골반 중심의 좌우 오차, 몸통 기울기·비대칭과 디텍터 대비 몸 중심 오차를 함께 판정합니다.',
            gap: '실제 척추가 아니라 어깨·골반 관절로 상체 중심 정렬을 계산합니다.',
            input_labels: ['Pose 어깨·골반', '디텍터 네 모서리', '몸통 중심']
        },
        {
            key: 'chest_contact', number: 3, class_index: 3,
            title: '두부·턱·디텍터 밀착 이상',
            description: '디텍터가 환자 중심보다 높아 두부가 흉부를 가리거나, 턱이 폐첨부(apex)를 가리거나, 디텍터와 몸이 밀착되지 않은 상태',
            coverage: 'manual_or_image_model', coverage_label: '촬영자 직접 확인',
            current_basis: '턱·폐첨부 가림과 실제 밀착 거리는 자동 합격·불합격에 사용하지 않으며 상대 Depth는 참고값으로만 표시합니다.',
            gap: '턱·폐첨부 좌표와 절대 접촉 거리가 없어 Depth·측면 카메라·근접 센서 등이 없으면 자동 확정하지 않습니다.',
            input_labels: ['촬영자 육안 확인', '상대 Depth(참고값)']
        },
        {
            key: 'chest_capture_range', number: 4, class_index: 4,
            title: '기준 흉부 정렬·촬영 범위',
            description: '양쪽 어깨와 어깨 너비로 추정한 흉부 영역이 디텍터 상단·좌우 경계를 벗어나거나 흉부 중심 정렬이 맞지 않는 상태',
            coverage: 'core', coverage_label: '자동 판정',
            current_basis: '디텍터 좌표계에서 추정 흉부 영역의 좌우·상단 여백, 포함 비율, 수평 중심 오차를 함께 판정합니다.',
            gap: '흉부 분할을 사용하지 않으며 하단 경계는 어깨 너비로 추정합니다. 골반·하체는 제외합니다.',
            input_labels: ['Pose 양쪽 어깨', '디텍터 네 모서리', '추정 흉부 영역']
        }
    ]
};

const MODEL_BEGINNER_GUIDES: any = {
    pose: {
        headline: '영상에서 사람의 관절을 찾는 모델입니다.',
        intro: '어깨·팔꿈치·골반처럼 자세를 확인하는 데 필요한 관절 위치를 찾아 숫자 좌표로 바꿉니다.',
        role: '사람과 주요 관절 찾기',
        result: '관절점과 자세선이 화면에 표시되고 자세판정 모델로 전달됩니다.',
        check: '상체와 양쪽 어깨·팔이 화면 안에 보이는지 확인하세요.',
        caution: '관절이 가려지거나 화면 밖에 있으면 안전하게 판정을 보류할 수 있습니다.',
        steps: [
            { number: 1, title: '영상 입력', description: '촬영 화면에서 사람을 찾습니다.' },
            { number: 2, title: '관절 찾기', description: '어깨·팔꿈치·골반 등 주요 관절 위치를 표시합니다.' },
            { number: 3, title: '좌표 전달', description: '찾은 관절 좌표를 자세판정 모델에 넘깁니다.' }
        ]
    },
    bucky: {
        headline: '영상에서 촬영판(버키)의 위치를 찾는 모델입니다.',
        intro: '촬영판의 네 모서리와 중심을 찾아 사람이 촬영 범위 안에 올바르게 서 있는지 비교할 기준을 만듭니다.',
        role: '촬영판 위치와 범위 찾기',
        result: '촬영판 외곽선과 중심점이 화면에 표시됩니다.',
        check: '촬영판 전체 테두리가 화면 안에 보이고 사람에게 가려지지 않았는지 확인하세요.',
        caution: '모서리가 많이 가려지거나 화면 밖이면 잘못된 위치를 쓰지 않고 다시 탐색합니다.',
        steps: [
            { number: 1, title: '영상 입력', description: '촬영 화면에서 촬영판 후보를 찾습니다.' },
            { number: 2, title: '경계 확인', description: '네 모서리와 중심이 실제 촬영판 모양인지 확인합니다.' },
            { number: 3, title: '범위 전달', description: '확정한 촬영판 범위를 자세판정 모델에 넘깁니다.' }
        ]
    },
    integrated: {
        headline: '관절과 촬영판 정보를 모아 최종 자세를 안내하는 모델입니다.',
        intro: '자세모델과 버키모델의 결과를 함께 보고 어깨 위치, 몸 중심, 촬영 범위 등 운영 판정 기준을 확인합니다.',
        role: '두 모델 결과를 합쳐 최종 판정',
        result: '정상, 자세 교정 필요 또는 판정 보류로 안내합니다.',
        check: '자동 안내와 함께 턱·흉부 밀착처럼 촬영자가 직접 확인할 항목도 살펴보세요.',
        caution: '정보가 부족하거나 두 모델의 결과가 충돌하면 무리하게 합격 처리하지 않고 판정을 보류합니다.',
        steps: [
            { number: 1, title: '결과 모으기', description: '관절 좌표와 촬영판 범위를 함께 받습니다.' },
            { number: 2, title: '기준 비교', description: '운영 중인 4개 자세 기준과 비교합니다.' },
            { number: 3, title: '최종 안내', description: '정상·교정 필요·판정 보류 중 하나로 안내합니다.' }
        ]
    }
};

@Component({ standalone: false,
    selector: 'wiz-page-xray-models',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.models/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100vh;
}

.model-page {
  min-height: 100vh;
}

.model-page > main > section,
.model-page > main > details {
  border-radius: 0.75rem;
}

details > summary::-webkit-details-marker {
  display: none;
}

.details-chevron {
  transition: transform 160ms ease;
}

details[open] > summary .details-chevron {
  transform: rotate(180deg);
}

button {
  transition: border-color 120ms ease, background-color 120ms ease, opacity 120ms ease;
}

button:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

summary:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: -2px;
}`],
})
export class PageXrayModelsComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public operatingLoading: boolean = true;
    public refreshing: boolean = false;
    public rebuildBusy: boolean = false;
    public rollbackBusyName: string = '';
    public deployBusyId: string = '';
    public approvalBusyId: string = '';
    public postureSelectionBusy: boolean = false;
    public testedModelBusyId: string = '';
    public criteriaDetailOpen: boolean = false;
    public modelTechnicalDetailOpen: boolean = false;
    public previousModelTab: string = 'pose';
    public postureSelectionDraft: string = 'legacy';
    public notice: string = '';
    public errorMessage: string = '';
    public selectedModel: any = null;
    public selectedApprovalJob: any = null;
    public state: any = {
        reference: {
            current: {},
            backups: [],
            core_features: []
        },
        posture_criteria: FOUR_POSTURE_CRITERIA,
        posture_classifier: {
            ready: true,
            mode: 'normalized_rule_baseline',
            image_classifier: { ready: false, training_image_count: 0 }
        },
        posture_operating_selection: {
            selected_id: 'legacy', selected_mode: 'legacy', choices: [], can_rollback: false
        },
        release: {
            current_version: 0,
            current_label: null,
            next_version: 1,
            all_models_ready: false,
            history: []
        },
        models: [],
        tested_models: { pose: [], bucky: [] },
        research_models: [],
        experiments: [],
        latest_classifier: null,
        timeline: [],
        retraining: {
            active_count: 0,
            processing_count: 0,
            counts: {},
            by_model: {},
            jobs: []
        }
    };

    private noticeTimer: any = null;
    private statusTimer: any = null;
    private detailOpener: HTMLElement | null = null;
    private approvalOpener: HTMLElement | null = null;
    private statusRequestGeneration: number = 0;
    private statusRequestInFlight: boolean = false;
    private hasStatusPayload: boolean = false;
    private statusErrorActive: boolean = false;
    private destroyed: boolean = false;
    private originalBodyOverflow: string | null = null;
    private operatingTrainingEvidence: any = null;
    private readonly operatingSnapshotKey = 'xray.model-manager.operating.v2';
    private readonly operatingSnapshotAsset = '/assets/xray-operating-models.json';
    private readonly operatingFallbackApi = '/wiz/api/page.xray.models/operating_status_v1';
    private readonly postureOperatingApi = '/wiz/api/page.xray.models_runtime_v1/request';

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( TranslateService    )         public translate: TranslateService    ) { }

    public async ngOnInit() {
        this.destroyed = false;
        this.restoreOperatingSnapshot();
        const operatingStatusRequest = this.fetchOperatingStatus().catch(() => ({
            code: 0,
            data: {}
        }));
        await this.service.init(this);
        void this.loadOperatingStatus(operatingStatusRequest);
        void this.loadStatus();
    }

    private async fetchOperatingStatus(): Promise<any> {
        const bundledResponse = await this.fetchBundledOperatingStatus();
        if (bundledResponse.code === 200) return bundledResponse;

        const fastResponse = await this.postureOperatingCall('operating').catch(() => ({
            code: 0,
            data: {}
        }));
        if (fastResponse.code === 200) return fastResponse;

        const response = await fetch(this.operatingFallbackApi, {
            method: 'POST', credentials: 'same-origin'
        });
        const body = await response.json().catch(() => ({}));
        return {
            code: Number(body?.code || response.status),
            data: body?.data || body || {}
        };
    }

    private async fetchBundledOperatingStatus(): Promise<any> {
        try {
            const response = await fetch(this.operatingSnapshotAsset, {
                method: 'GET', cache: 'no-cache', credentials: 'same-origin'
            });
            const body = await response.json().catch(() => ({}));
            return {
                code: response.ok ? 200 : response.status,
                data: body?.data || body || {}
            };
        } catch (_) {
            return { code: 0, data: {} };
        }
    }

    private async loadOperatingStatus(request: Promise<any>) {
        try {
            const { code, data } = await request;
            if (code === 200 && !this.destroyed) {
                this.applyOperatingPayload(data);
            }
        } catch (_) {
            // 전체 상태 조회가 이어서 동일 정보를 채우므로 빠른 조회 실패는 별도 노출하지 않습니다.
        } finally {
            if (this.destroyed) return;
            this.operatingLoading = false;
            await this.service.render();
        }
    }

    private async postureOperatingCall(action: string, payload: any = {}): Promise<any> {
        const form = new FormData();
        form.append('action', action);
        for (const [key, value] of Object.entries(payload || {})) {
            form.append(key, value == null ? '' : String(value));
        }
        const response = await fetch(this.postureOperatingApi, {
            method: 'POST', body: form, credentials: 'same-origin'
        });
        const body = await response.json().catch(() => ({}));
        return {
            code: Number(body?.code || response.status),
            data: body?.data || body || {}
        };
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.statusRequestGeneration += 1;
        if (this.noticeTimer) clearTimeout(this.noticeTimer);
        this.clearStatusTimer();
        this.restoreBodyScroll();
    }

    @HostListener('document:keydown', ['$event'])
    public handleDocumentKeydown(event: KeyboardEvent) {
        const approvalOpen = Boolean(this.selectedApprovalJob);
        if (!approvalOpen && !this.selectedModel) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            if (approvalOpen) {
                if (!this.approvalBusyId) void this.closeCandidateApproval();
            } else {
                void this.closeModelDetail();
            }
            return;
        }
        if (event.key !== 'Tab') return;

        const selector = approvalOpen
            ? '[data-candidate-approval-panel]'
            : '[data-model-detail-panel]';
        const panel = document.querySelector(selector) as HTMLElement | null;
        if (!panel) return;
        const focusable = Array.from(panel.querySelectorAll<HTMLElement>(
            'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ));
        if (!focusable.length) {
            event.preventDefault();
            panel.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement as HTMLElement | null;
        if (!panel.contains(active)) {
            event.preventDefault();
            first.focus();
        } else if (event.shiftKey && active === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && active === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public go(path: string) {
        this.service.href(path);
    }

    public async toggleCriteriaDetail() {
        this.criteriaDetailOpen = !this.criteriaDetailOpen;
        await this.service.render();
    }

    public get current(): any {
        return this.state?.reference?.current || {};
    }

    public get release(): any {
        return this.state?.release || {};
    }

    public currentReleaseUpdatedAt(): any {
        return this.release?.history?.[0]?.created_at || null;
    }

    public get postureCriteria(): any[] {
        return this.state?.posture_criteria?.items || [];
    }

    public get models(): any[] {
        return this.state?.models || [];
    }

    public get integratedModels(): any[] {
        return this.models.filter((model: any) => model?.key === 'integrated');
    }

    public get operatingModels(): any[] {
        const order: any = { pose: 1, bucky: 2, integrated: 3 };
        return this.models
            .filter((model: any) => ['pose', 'bucky', 'integrated'].includes(model?.key))
            .slice()
            .sort((a: any, b: any) => (order[a?.key] || 99) - (order[b?.key] || 99));
    }

    public operatingModelLabel(model: any): string {
        const labels: any = {
            pose: '자세모델',
            bucky: '버키모델',
            integrated: '자세판정 모델'
        };
        return labels[model?.key] || model?.short_name || model?.name || '모델';
    }

    public modelBeginnerGuide(model: any): any {
        return MODEL_BEGINNER_GUIDES[model?.key] || MODEL_BEGINNER_GUIDES.integrated;
    }

    public async toggleModelTechnicalDetail() {
        this.modelTechnicalDetailOpen = !this.modelTechnicalDetailOpen;
        await this.service.render();
    }

    public previousModelLabel(key: string): string {
        const labels: any = {
            pose: '자세모델',
            bucky: '버키모델',
            integrated: '판정모델'
        };
        return labels[key] || '모델';
    }

    public get previousModelGroups(): any[] {
        return this.operatingModels.map((model: any) => {
            const seen = new Set<string>();
            const versions = (model?.history || [])
                .filter((item: any) => (
                    item?.is_current !== true
                    && (item?.kind === 'release' || item?.kind === 'legacy_model')
                    && (item?.native_version || item?.label)
                ))
                .sort((a: any, b: any) => String(b?.created_at || '').localeCompare(String(a?.created_at || '')))
                .filter((item: any) => {
                    const key = String(item?.native_version || item?.id || item?.label || '');
                    if (!key || seen.has(key)) return false;
                    seen.add(key);
                    return true;
                })
                .slice(0, 8);
            return {
                key: model?.key,
                label: this.previousModelLabel(model?.key),
                versions
            };
        });
    }

    public get selectedPreviousModelGroup(): any {
        return this.previousModelGroups.find((group: any) => group?.key === this.previousModelTab)
            || this.previousModelGroups[0]
            || { key: this.previousModelTab, label: this.previousModelLabel(this.previousModelTab), versions: [] };
    }

    public async selectPreviousModelTab(key: string) {
        if (!['pose', 'bucky', 'integrated'].includes(key)) return;
        this.previousModelTab = key;
        await this.service.render();
    }

    public get testedPoseModels(): any[] {
        return this.state?.tested_models?.pose || [];
    }

    public get testedBuckyModels(): any[] {
        return this.state?.tested_models?.bucky || [];
    }

    public get testedPostureModels(): any[] {
        return this.postureOperatingChoices.filter((choice: any) => (
            choice?.kind === 'trained_hybrid' && choice?.video_test_passed === true
        ));
    }

    public async activateTestedPoseModel(model: any) {
        if (!model?.can_activate || !model?.id || this.testedModelBusyId) return;
        if (!window.confirm(
            `${model.label || model.model_id}을(를) 실제 Pose 운영 모델로 변경할까요?\n\nBucky 모델은 변경되지 않으며, 기존 Pose 설정은 rollback용으로 백업됩니다.`
        )) return;
        this.testedModelBusyId = model.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('activate_tested_pose_model_v1', {
                model_id: model.id,
                expected_sha256: model.weight_sha256,
            });
            if (code !== 200) throw new Error(data?.message || 'Pose 운영 모델을 변경하지 못했습니다.');
            this.applyPayload(data);
            this.hasStatusPayload = true;
            this.showNotice('테스트 통과 Pose 모델을 운영에 적용했습니다. Bucky 모델은 그대로 유지했습니다.');
            if (data?.warning) this.errorMessage = data.warning;
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Pose 운영 모델을 변경하지 못했습니다.');
        } finally {
            this.testedModelBusyId = '';
            await this.service.render();
        }
    }

    public async activateTestedBuckyModel(model: any) {
        if (!model?.can_activate || !model?.id || this.testedModelBusyId) return;
        if (!window.confirm(
            `${model.label || model.model_id}을(를) 실제 Bucky 운영 모델로 변경할까요?\n\nPose 모델은 변경되지 않으며, 기존 Bucky 설정은 rollback용으로 백업됩니다.`
        )) return;
        this.testedModelBusyId = model.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('activate_tested_bucky_model_v1', {
                model_id: model.id,
                expected_sha256: model.weight_sha256,
            });
            if (code !== 200) throw new Error(data?.message || 'Bucky 운영 모델을 변경하지 못했습니다.');
            this.applyPayload(data);
            this.hasStatusPayload = true;
            this.showNotice('테스트 통과 Bucky 모델을 운영에 적용했습니다. Pose 모델은 그대로 유지했습니다.');
            if (data?.warning) this.errorMessage = data.warning;
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Bucky 운영 모델을 변경하지 못했습니다.');
        } finally {
            this.testedModelBusyId = '';
            await this.service.render();
        }
    }

    public async activateTestedPostureModel(model: any) {
        if (!model?.id || model?.operating || model?.eligible !== true || this.testedModelBusyId) return;
        if (!window.confirm(
            `${model.title || '자세 판정 모델'}을(를) 실제 자세 판정 운영 모델로 적용할까요?\n\n동영상 테스트 통과 후보를 우선 사용하고, 불확실하거나 기존 규칙과 충돌하면 규칙 안전망을 사용합니다.`
        )) return;
        this.testedModelBusyId = model.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await this.postureOperatingCall('apply', {
                selection_id: model.id,
                risk_acknowledged: true,
            });
            if (code !== 200) throw new Error(data?.message || '자세 판정 운영 모델을 변경하지 못했습니다.');
            this.state.posture_operating_selection = data.posture_operating_selection;
            this.postureSelectionDraft = data.posture_operating_selection?.selected_id || 'legacy';
            this.showNotice('테스트 통과 자세 판정 모델을 운영에 적용했습니다.');
        } catch (error: any) {
            this.errorMessage = this.callError(error, '자세 판정 운영 모델을 변경하지 못했습니다.');
        } finally {
            this.testedModelBusyId = '';
            await this.service.render();
        }
    }

    public operatingDisplayPending(): boolean {
        return this.operatingLoading
            || (this.loading && !this.operatingModels.length);
    }

    public get researchModels(): any[] {
        return this.state?.research_models || [];
    }

    public get postureOperatingSelection(): any {
        return this.state?.posture_operating_selection || {};
    }

    public get postureOperatingChoices(): any[] {
        return this.postureOperatingSelection?.choices || [];
    }

    public get activePostureChoice(): any {
        return this.postureOperatingChoices.find((choice: any) => choice?.operating)
            || this.postureOperatingChoices.find((choice: any) => choice?.id === this.postureOperatingSelection?.selected_id)
            || null;
    }

    public postureModeLabel(): string {
        return this.postureOperatingSelection?.selected_mode === 'hybrid'
            ? '학습모델 + 규칙 안전망'
            : '정규화 좌표 규칙';
    }

    public postureRiskLabel(choice: any): string {
        if (choice?.risk_level === 'independent_validation_pending') return '외부검증 대기';
        if (choice?.risk_level === 'baseline') return '기준 방식';
        return choice?.eligible === false ? '적용 불가' : '사용 가능';
    }

    public postureChoicePercent(value: any): string {
        const number = Number(value);
        return Number.isFinite(number) ? `${(number * 100).toFixed(1)}%` : '평가 없음';
    }

    public selectPostureDraft(choice: any) {
        if (!choice?.id || this.postureSelectionBusy) return;
        this.postureSelectionDraft = choice.id;
    }

    public async applyPostureOperatingSelection() {
        if (this.postureSelectionBusy) return;
        const choice = this.postureOperatingChoices.find((item: any) => item?.id === this.postureSelectionDraft);
        if (!choice || choice?.operating) return;
        const confirmed = window.confirm(
            choice.kind === 'legacy'
                ? '현재 규칙 방식으로 자세 판정을 전환할까요?'
                : '2026.08.11 자세 판정모델을 실제 판정에 적용할까요?\n\n독립 외부검증은 아직 완료되지 않았습니다. 새 모델을 우선 사용하고, 불확실하거나 기존 규칙과 충돌하면 안전하게 판단 보류됩니다.'
        );
        if (!confirmed) return;
        this.postureSelectionBusy = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await this.postureOperatingCall('apply', {
                selection_id: choice.id,
                risk_acknowledged: choice.kind !== 'legacy'
            });
            if (code === 200) {
                this.state.posture_operating_selection = data.posture_operating_selection;
                this.postureSelectionDraft = data.posture_operating_selection?.selected_id || 'legacy';
                this.showNotice(`${choice.title}을(를) 실제 자세 판정에 적용했습니다.`);
            } else {
                this.errorMessage = data?.message || '자세 판정 운영 모델을 변경하지 못했습니다.';
            }
        } catch (error: any) {
            this.errorMessage = this.callError(error, '자세 판정 운영 모델을 변경하지 못했습니다.');
        } finally {
            this.postureSelectionBusy = false;
            await this.service.render();
        }
    }

    public async rollbackPostureOperatingSelection() {
        if (this.postureSelectionBusy || !this.postureOperatingSelection?.can_rollback) return;
        if (!window.confirm('직전 자세 판정 운영 방식으로 되돌릴까요?')) return;
        this.postureSelectionBusy = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await this.postureOperatingCall('rollback');
            if (code === 200) {
                this.state.posture_operating_selection = data.posture_operating_selection;
                this.postureSelectionDraft = data.posture_operating_selection?.selected_id || 'legacy';
                this.showNotice('직전 자세 판정 운영 방식으로 되돌렸습니다.');
            } else this.errorMessage = data?.message || '되돌리지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '되돌리지 못했습니다.');
        } finally {
            this.postureSelectionBusy = false;
            await this.service.render();
        }
    }

    public get timeline(): any[] {
        return this.state?.timeline || [];
    }

    public get retraining(): any {
        return this.state?.retraining || {};
    }

    public get latestValidation(): any {
        return this.latestValidationJob?.validation_summary || null;
    }

    public get latestValidationJob(): any {
        const jobs = this.retraining?.jobs || [];
        return jobs
            .filter((item: any) => (
                item?.status === 'rejected'
                && item?.validation_summary?.gate_passed === false
            ))
            .slice()
            .sort((a: any, b: any) => {
                const aTime = new Date(a?.finished_at || a?.updated_at || a?.created_at || 0).getTime();
                const bTime = new Date(b?.finished_at || b?.updated_at || b?.created_at || 0).getTime();
                return bTime - aTime;
            })[0] || null;
    }

    public get awaitingApprovalJobs(): any[] {
        const jobs = Array.isArray(this.retraining?.jobs)
            ? this.retraining.jobs
            : [];
        return jobs
            .filter((item: any) => (
                item?.status === 'awaiting_approval'
                && item?.can_approve === true
                && (item?.candidate || item?.candidate_version)
            ))
            .slice()
            .sort((a: any, b: any) => {
                const aTime = new Date(a?.updated_at || a?.created_at || 0).getTime();
                const bTime = new Date(b?.updated_at || b?.created_at || 0).getTime();
                return bTime - aTime;
            });
    }

    public awaitingApprovalCount(): number {
        return this.awaitingApprovalJobs.length;
    }

    public hasAwaitingApprovalCandidate(): boolean {
        return this.awaitingApprovalCount() > 0;
    }

    public candidateIdentity(job: any): any {
        const validation = job?.validation_summary || {};
        return job?.candidate || validation?.candidate || {
            version: job?.candidate_version || validation?.candidate_version,
            sha256: job?.candidate_sha256 || validation?.candidate_sha256
        };
    }

    public candidateVersion(job: any): string {
        const candidate = this.candidateIdentity(job);
        return String(candidate?.version || job?.candidate_version || '버전 미등록');
    }

    public candidateHash(job: any): string {
        const candidate = this.candidateIdentity(job);
        return String(
            candidate?.sha256
            || candidate?.model_sha256
            || job?.candidate_sha256
            || '해시 미등록'
        );
    }

    public candidateComparisonRows(job: any): any[] {
        const validation = job?.validation_summary || {};
        const comparison = job?.before_after_comparison
            || validation?.before_after_comparison
            || {};
        const directRows = comparison?.rows
            || comparison?.comparison_rows
            || validation?.comparison_rows
            || validation?.comparison_table;
        if (Array.isArray(directRows) && directRows.length) {
            const scopedPointKeys = new Set([
                'top_left',
                'top_mid',
                'top_right',
                'left_mid',
                'right_mid',
                'bottom_left',
                'bottom_mid',
                'bottom_right',
                'center_cross'
            ]);
            return directRows.map((item: any, index: number) => {
                const baseKey = item?.key || `comparison-${index}`;
                const scope = String(item?.scope || 'comparison');
                const scopeLabel = item?.scope === 'corrected_holdout'
                    ? '교정 표본'
                    : item?.scope === 'normal_holdout'
                        ? '정상 holdout'
                        : '';
                const baseLabel = item?.label
                    || this.buckyPointLabel(item?.key);
                return {
                    key: `${scope}:${baseKey}`,
                    label: scopeLabel && scopedPointKeys.has(baseKey)
                        ? `${scopeLabel} · ${baseLabel}`
                        : baseLabel,
                    before: item?.before ?? item?.active ?? item?.before_percent,
                    after: item?.after ?? item?.candidate ?? item?.after_percent,
                    passed: item?.passed ?? item?.improved ?? item?.non_regression,
                    direction: item?.direction || 'lower',
                    valueIsPercent: String(item?.metric || '').endsWith('_percent')
                        || item?.before_percent !== undefined
                        || item?.after_percent !== undefined
                };
            });
        }

        const rows: any[] = [];
        const order = [
            'top_left',
            'top_mid',
            'top_right',
            'left_mid',
            'right_mid',
            'bottom_left',
            'bottom_mid',
            'bottom_right'
        ];
        const before = comparison?.before || {};
        const after = comparison?.after || {};
        const perKeypoint = comparison?.per_keypoint
            || comparison?.corners
            || comparison?.corner_error?.per_keypoint
            || {};
        const beforeByPoint = before?.per_keypoint_nme || {};
        const afterByPoint = after?.per_keypoint_nme || {};
        const pointKeys = order.filter((key: string) => (
            perKeypoint?.[key]
            || beforeByPoint?.[key] !== undefined
            || afterByPoint?.[key] !== undefined
        ));
        for (const key of pointKeys) {
            const item = perKeypoint?.[key] || {};
            const beforeValue = item?.before ?? beforeByPoint?.[key];
            const afterValue = item?.after ?? afterByPoint?.[key];
            rows.push({
                key,
                label: this.buckyPointLabel(key),
                before: beforeValue,
                after: afterValue,
                passed: item?.passed
                    ?? item?.improved
                    ?? this.nonRegression(beforeValue, afterValue, 'lower'),
                direction: 'lower'
            });
        }
        if (!pointKeys.length && comparison?.corner_error) {
            rows.push(this.comparisonRow(
                'corner_error',
                '외곽점 평균 오차',
                comparison.corner_error,
                'lower'
            ));
        }
        const center = comparison?.center_error || (
            before?.center_error !== undefined
            || after?.center_error !== undefined
                ? {
                    before: before?.center_error,
                    after: after?.center_error,
                    improved: comparison?.delta?.center_error !== undefined
                        ? Number(comparison.delta.center_error) <= 0
                        : undefined
                }
                : null
        );
        if (center) {
            rows.push(this.comparisonRow(
                'center_error',
                '중앙 보조점 오차',
                center,
                'lower'
            ));
        }
        const normalHoldout = comparison?.normal_holdout || (
            before?.normal_retention_error !== undefined
            || after?.normal_retention_error !== undefined
                ? {
                    before: before?.normal_retention_error,
                    after: after?.normal_retention_error,
                    non_regression: comparison?.checks
                        ?.normal_retention_non_regression?.passed
                }
                : null
        );
        if (normalHoldout) {
            rows.push(this.comparisonRow(
                'normal_holdout',
                '정상 자세 holdout 오차',
                normalHoldout,
                'lower'
            ));
        }
        if (comparison?.normal_holdout_pck) {
            rows.push(this.comparisonRow(
                'normal_holdout_pck',
                '정상 자세 holdout PCK',
                comparison.normal_holdout_pck,
                'higher'
            ));
        }
        return rows;
    }

    public candidateComparisonOutcome(row: any): string {
        const before = Number(row?.before);
        const after = Number(row?.after);
        if (!Number.isFinite(after)) return '미산출';
        if (row?.passed !== true) return '회귀';
        if (!Number.isFinite(before)) return '통과';
        const improved = row?.direction === 'higher'
            ? after > before
            : after < before;
        return improved ? '개선' : '비회귀';
    }

    public candidateComparisonClass(row: any): string {
        if (row?.passed !== true) return 'text-red-700';
        return this.candidateComparisonOutcome(row) === '개선'
            ? 'text-emerald-700'
            : 'text-sky-700';
    }

    public canApproveCandidate(job: any): boolean {
        return Boolean(
            job?.status === 'awaiting_approval'
            && job?.can_approve === true
            && job?.id
            && job?.updated_at
            && this.candidateComparisonRows(job).length > 0
            && !this.approvalBusyId
        );
    }

    public async loadStatus(silent: boolean = false) {
        if (this.destroyed) return;
        this.clearStatusTimer();
        if (this.statusRequestInFlight) {
            return;
        }

        this.statusRequestInFlight = true;
        const requestGeneration = ++this.statusRequestGeneration;
        const showInitialLoading = !this.hasStatusPayload;
        let succeeded = false;
        this.loading = showInitialLoading;
        this.refreshing = !showInitialLoading;
        if (!silent) {
            this.errorMessage = '';
            this.statusErrorActive = false;
        }
        await this.service.render();
        try {
            const { code, data } = await wiz.call('status_metrics_v3', {});
            if (
                requestGeneration !== this.statusRequestGeneration
                || this.destroyed
            ) return;
            if (code === 200) {
                this.applyPayload(data);
                this.hasStatusPayload = true;
                succeeded = !data?.retraining?.warning;
                if (this.statusErrorActive) this.errorMessage = '';
                this.statusErrorActive = false;
            } else {
                this.errorMessage = this.publicDetectorTerminology(
                    data?.message || '모델 관리 정보를 불러오지 못했습니다.'
                );
                this.statusErrorActive = true;
            }
        } catch (error: any) {
            if (
                requestGeneration === this.statusRequestGeneration
                && !this.destroyed
            ) {
                this.errorMessage = this.callError(
                    error,
                    '모델 관리 정보를 불러오지 못했습니다.'
                );
                this.statusErrorActive = true;
            }
        } finally {
            const isCurrent = requestGeneration === this.statusRequestGeneration;
            this.statusRequestInFlight = false;
            if (this.destroyed) return;
            if (isCurrent) {
                this.loading = false;
                this.refreshing = false;
                await this.service.render();
                this.scheduleStatusRefresh(!succeeded);
            } else {
                this.scheduleStatusRefresh();
            }
        }
    }

    public async rebuildReference() {
        if (this.rebuildBusy) return;
        const currentLabel = this.release?.current_label || '현재 버전';
        const nextLabel = `v${this.release?.next_version || 1}`;
        const confirmed = window.confirm(
            `현재 자세·디텍터 구성요소와 판정 기준으로 운영 모델을 다시 생성하고 실제 판정에 적용할까요?\n\n변경 사항이 있으면 운영 버전이 ${currentLabel}에서 ${nextLabel}(으)로 올라가며, 완료 즉시 실제 판정에 적용됩니다. 같은 구성이면 현재 버전을 유지하고, AI 모델을 새로 학습하지는 않습니다.`
        );
        if (!confirmed) return;

        this.pauseStatusRefresh();
        this.rebuildBusy = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('rebuild_reference_v2', {});
            if (code === 200) {
                this.applyPayload(data);
                const used = data?.build?.used || 0;
                const releaseLabel = data?.release?.current_label || nextLabel;
                if (data?.build?.release_changed) {
                    this.showNotice(`운영 모델을 ${releaseLabel}(으)로 재생성해 실제 판정에 적용했습니다. 기준 데이터 ${used}장 반영`);
                } else {
                    this.showNotice(`운영 모델을 확인했습니다. 변경된 구성이 없어 ${releaseLabel} 버전을 그대로 유지합니다.`);
                }
            } else {
                if (data?.models) this.applyPayload(data);
                this.errorMessage = this.publicDetectorTerminology(
                    data?.message || '운영 모델을 변경하지 못했습니다.'
                );
            }
        } catch (error: any) {
            this.errorMessage = this.callError(error, '운영 모델을 변경하지 못했습니다.');
        }
        this.rebuildBusy = false;
        await this.service.render();
        this.scheduleStatusRefresh();
    }

    public async openModelDetail(model: any, event?: Event) {
        this.detailOpener = (event?.currentTarget as HTMLElement) || null;
        this.selectedModel = model || null;
        this.modelTechnicalDetailOpen = false;
        if (this.selectedModel) this.lockBodyScroll();
        await this.service.render();
        setTimeout(() => {
            const closeButton = document.querySelector('[data-model-detail-close]') as HTMLElement | null;
            const panel = document.querySelector('[data-model-detail-panel]') as HTMLElement | null;
            (closeButton || panel)?.focus();
        }, 0);
    }

    public async closeModelDetail() {
        const opener = this.detailOpener;
        this.selectedModel = null;
        this.modelTechnicalDetailOpen = false;
        this.detailOpener = null;
        if (!this.selectedApprovalJob) this.restoreBodyScroll();
        await this.service.render();
        setTimeout(() => opener?.focus(), 0);
    }

    public async closeError() {
        this.errorMessage = '';
        this.statusErrorActive = false;
        await this.service.render();
    }

    public async rollbackReference(item: any) {
        if (!item?.rollback_allowed || this.rollbackBusyName) return;
        const confirmed = window.confirm(
            `${item.version_id || item.name} 기준 데이터로 복원할까요? 현재 기준 데이터는 먼저 새 백업으로 보관됩니다.`
        );
        if (!confirmed) return;

        this.pauseStatusRefresh();
        this.rollbackBusyName = item.name;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('rollback_reference', {
                filename: item.name
            });
            if (code === 200) {
                this.applyPayload(data);
                this.showNotice(`${item.version_id || item.name} 기준 데이터로 복원했습니다.`);
            } else {
                this.errorMessage = this.publicDetectorTerminology(
                    data?.message || '기준 데이터 복원에 실패했습니다.'
                );
            }
        } catch (error: any) {
            this.errorMessage = this.callError(error, '기준 데이터 복원에 실패했습니다.');
        }
        this.rollbackBusyName = '';
        await this.service.render();
        this.scheduleStatusRefresh();
    }

    public async deployExperiment(item: any) {
        if (!item?.can_deploy || this.deployBusyId) return;
        const confirmed = window.confirm(
            '이 실험을 배포 후보로 표시할까요? 상태만 기록하며 실제 서비스 모델은 변경되지 않습니다.'
        );
        if (!confirmed) return;

        this.pauseStatusRefresh();
        this.deployBusyId = item.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('deploy_experiment', {
                experiment_id: item.id
            });
            if (code === 200) {
                this.applyPayload(data);
                this.showNotice('배포 후보 표시만 저장했습니다. 실제 서비스 모델은 변경하지 않았습니다.');
            } else {
                this.errorMessage = this.publicDetectorTerminology(
                    data?.message || '배포 후보 표시를 저장하지 못했습니다.'
                );
            }
        } catch (error: any) {
            this.errorMessage = this.callError(error, '배포 후보 표시를 저장하지 못했습니다.');
        }
        this.deployBusyId = '';
        await this.service.render();
        this.scheduleStatusRefresh();
    }

    public async openCandidateApproval(job: any, event?: Event) {
        if (!this.canApproveCandidate(job)) return;
        this.approvalOpener = (event?.currentTarget as HTMLElement) || null;
        this.selectedApprovalJob = job;
        this.lockBodyScroll();
        await this.service.render();
        setTimeout(() => {
            const panel = document.querySelector(
                '[data-candidate-approval-panel]'
            ) as HTMLElement | null;
            const closeButton = document.querySelector(
                '[data-candidate-approval-close]'
            ) as HTMLElement | null;
            (closeButton || panel)?.focus();
        }, 0);
    }

    public async closeCandidateApproval() {
        if (this.approvalBusyId) return;
        const opener = this.approvalOpener;
        this.selectedApprovalJob = null;
        this.approvalOpener = null;
        if (!this.selectedModel) this.restoreBodyScroll();
        await this.service.render();
        setTimeout(() => opener?.focus(), 0);
    }

    public async approveCandidate() {
        const job = this.selectedApprovalJob;
        if (!this.canApproveCandidate(job)) return;
        this.pauseStatusRefresh();
        this.approvalBusyId = job.id;
        this.errorMessage = '';
        await this.service.render();
        let stale = false;
        let approvalSaved = false;
        try {
            const { code, data } = await wiz.call(
                'approve_retraining_candidate',
                {
                    job_id: job.id,
                    expected_updated_at: job.updated_at
                }
            );
            if (code === 200) {
                if (Array.isArray(data?.models)) this.applyPayload(data);
                this.selectedApprovalJob = null;
                this.approvalOpener = null;
                if (!this.selectedModel) this.restoreBodyScroll();
                approvalSaved = true;
                this.showNotice(data?.approval?.warning
                    || data?.warning
                    || '후보 승격을 승인했습니다. 운영 반영 워커가 검증된 체크포인트를 처리합니다.');
            } else {
                stale = code === 409;
                this.errorMessage = this.publicDetectorTerminology(
                    data?.message
                    || '후보 승격 승인을 저장하지 못했습니다.'
                );
            }
        } catch (error: any) {
            this.errorMessage = this.callError(
                error,
                '후보 승격 승인을 저장하지 못했습니다.'
            );
        }
        this.approvalBusyId = '';
        await this.service.render();
        if (stale) {
            this.selectedApprovalJob = null;
            this.approvalOpener = null;
            if (!this.selectedModel) this.restoreBodyScroll();
            await this.loadStatus(true);
            return;
        }
        if (approvalSaved) {
            await this.loadStatus(true);
            return;
        }
        this.scheduleStatusRefresh(true, 1000);
    }

    public formatDate(value: any): string {
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    public formatPercent(value: any): string {
        if (value === null || value === undefined || value === '') return '—';
        const number = Number(value);
        if (!Number.isFinite(number)) return '—';
        return `${number.toFixed(2)}%`;
    }

    public formatPerformance(item: any): string {
        const modelKey = item?.model_key || item?.key;
        const isOperatingRelease = item?.kind !== 'experiment';
        if (item?.metric_state === 'not_independently_validated'
            || (isOperatingRelease && (modelKey === 'pose' || modelKey === 'integrated'))) {
            return '미산출';
        }
        return this.formatPercent(item?.performance);
    }

    public operatingModelCount(): number {
        return this.models.filter((model: any) => model?.operating).length;
    }

    public awaitingReviewCount(): number {
        return Math.max(0, Number(this.retraining?.counts?.awaiting_review || 0));
    }

    public accumulatingCount(): number {
        const count = Math.max(0, Number(this.retraining?.counts?.accumulating || 0));
        if (count > 0) return count;
        return this.models.filter((model: any) => (
            model?.retraining?.latest_job?.status === 'accumulating'
        )).length;
    }

    public hasAccumulatingRetraining(): boolean {
        return this.accumulatingCount() > 0;
    }

    public hasActiveRetraining(): boolean {
        const counts = this.retraining?.counts || {};
        const activeStatuses = new Set([
            'queued',
            'promotion_queued',
            'retry_wait',
            'running',
            'validating',
            'promoting'
        ]);
        const latestJobActive = this.models.some((model: any) => (
            activeStatuses.has(model?.retraining?.latest_job?.status)
        ));
        return Boolean(
            Number(this.retraining?.processing_count || 0) > 0
            || Number(counts.queued || 0) > 0
            || Number(counts.promotion_queued || 0) > 0
            || this.retraining?.worker_running
            || this.retraining?.kick?.started
            || latestJobActive
        );
    }

    public hasRetrainingAttention(): boolean {
        return this.hasActiveRetraining()
            || this.hasAccumulatingRetraining()
            || this.hasAwaitingApprovalCandidate()
            || this.awaitingReviewCount() > 0;
    }

    public dataReadinessItems(job: any): any[] {
        const currentStatuses = new Set([
            'accumulating',
            'queued',
            'promotion_queued',
            'retry_wait',
            'running',
            'validating',
            'promoting'
        ]);
        if (!currentStatuses.has(job?.status)) return [];
        const items = job?.data_readiness?.items;
        if (!Array.isArray(items)) return [];
        return items.filter((item: any) => (
            item?.key === 'manual_center' || item?.key === 'outer_frame'
        ));
    }

    public hasLatestDataReadiness(): boolean {
        return this.models.some((model: any) => (
            this.dataReadinessItems(model?.retraining?.latest_job).length > 0
        ));
    }

    public readinessRemainingLabel(item: any): string {
        const count = Math.max(0, Number(item?.annotation_count || 0));
        const minimum = Math.max(0, Number(item?.minimum || 0));
        if (minimum <= 0) return `${count}장 확보`;
        return `${count}/${minimum}장 · ${Math.max(0, minimum - count)}장 남음`;
    }

    public readinessIndependentLabel(item: any): string {
        const count = Math.max(0, Number(item?.independent_group_count || 0));
        const minimum = Math.max(0, Number(item?.minimum_independent_groups || 0));
        if (minimum <= 0) return `독립 그룹 ${count}개`;
        return `독립 그룹 ${count}/${minimum}개 · ${Math.max(0, minimum - count)}개 남음`;
    }

    public modelPlainDescription(model: any): string {
        const descriptions: any = {
            pose: '사람의 관절 위치를 찾아 기준 자세와 비교합니다.',
            bucky: '촬영판의 위치와 범위를 찾습니다.',
            integrated: '사람과 촬영판의 위치를 합쳐 최종 판정을 만듭니다.'
        };
        return descriptions[model?.key] || model?.description || '현재 서비스 판정에 사용하는 모델입니다.';
    }

    public modelDataRoleLabel(model: any): string {
        return model?.key === 'integrated' ? '연결 학습 데이터' : '검수 완료 라벨';
    }

    public modelDataSplitLabel(model: any): string {
        const train = Number(model?.training_sample_count || 0);
        const validation = Number(model?.validation_sample_count || 0);
        const test = Number(model?.test_sample_count || 0);
        if (!train && !validation && !test) return '세부 분할은 상세에서 확인';
        return `학습 ${train} · 검증 ${validation} · 테스트 ${test}`;
    }

    public reviewedTrainingCount(): number {
        return Math.max(0, ...this.operatingModels.map((model: any) => Number(model?.sample_count || 0)));
    }

    public performanceSummaryValue(item: any): string {
        const value = this.formatPerformance(item);
        return value === '미산출' ? '별도 검증 전' : value;
    }

    public performanceSummaryNote(item: any): string {
        const modelKey = item?.model_key || item?.key;
        if (!item?.operating) return '현재 운영 구성을 확인해 주세요.';
        if (item?.metric_state === 'not_independently_validated' || modelKey === 'pose' || modelKey === 'integrated') {
            return '파일과 구성은 정상이며, 독립 평가 정확도는 아직 없습니다.';
        }
        if (modelKey === 'bucky') {
            return '좌표를 찾는 성능 지표이며 정상·비정상 분류 정확도는 아닙니다.';
        }
        return item?.performance_basis || '자세한 계산 기준은 모델 구성에서 확인할 수 있습니다.';
    }

    public validationScopeLabel(validation: any): string {
        const active = Number(validation?.comparison_scope?.active_evaluated_points);
        const candidate = Number(validation?.comparison_scope?.candidate_evaluated_points);
        if (Number.isFinite(active) && active > 0 && active === candidate) {
            return `같은 ${active}개 평가점을`;
        }
        if (Number.isFinite(active) && active > 0 && Number.isFinite(candidate) && candidate > 0) {
            return `기존 ${active}개와 후보 ${candidate}개 평가점을`;
        }
        return '후보 검증 평가 범위를';
    }

    public performanceLabel(item: any): string {
        const modelKey = item?.model_key || item?.key;
        if (item?.kind !== 'experiment' && (modelKey === 'pose' || modelKey === 'integrated')) {
            return '독립 검증 정확도';
        }
        return item?.performance_label || '성능 지표';
    }

    public performanceBasis(item: any): string {
        const modelKey = item?.model_key || item?.key;
        if (item?.metric_state === 'not_independently_validated') {
            return item?.performance_basis || '미실시';
        }
        if (item?.kind !== 'experiment' && modelKey === 'pose') {
            return `미실시 · 기준 데이터 ${item?.performance_basis || '기록 없음'} 반영 (평가셋 아님)`;
        }
        if (item?.kind !== 'experiment' && modelKey === 'integrated') {
            return `미실시 · 운영 자체점검 ${item?.performance_basis || '기록 없음'} 통과 (정확도 아님)`;
        }
        return item?.performance_basis || '측정 기록 없음';
    }

    public formatRatioPercent(value: any): string {
        if (value === null || value === undefined || value === '') return '—';
        const number = Number(value);
        if (!Number.isFinite(number)) return '—';
        return `${(number * 100).toFixed(4)}%`;
    }

    public formatCandidateComparisonValue(row: any, value: any): string {
        if (value === null || value === undefined || value === '') return '—';
        const number = Number(value);
        if (!Number.isFinite(number)) return '—';
        if (row?.valueIsPercent) return `${number.toFixed(4)}%`;
        return this.formatRatioPercent(number);
    }

    public validationProgress(item: any): number {
        const progress = Number(item?.progress);
        if (!Number.isFinite(progress)) return 0;
        return Math.max(0, Math.min(100, progress * 100));
    }

    public validationCountLabel(item: any): string {
        const count = Math.max(0, Number(item?.annotation_count || 0));
        const minimum = Math.max(0, Number(item?.minimum || 0));
        return `${count}/${minimum}장`;
    }

    public validationIndependentLabel(item: any): string {
        const count = Number(item?.independent_group_count);
        if (!Number.isFinite(count)) return '독립 그룹 산정 불가';
        return `독립 유사그룹 ${Math.max(0, count)}개`;
    }

    public collectionMetadataLabel(value: any): string {
        const labels: any = {
            camera_angle: '촬영 각도',
            lighting: '조명',
            detector_model: '디텍터 기종',
            body_habitus: '체형'
        };
        return labels[value] || String(value || '미등록 항목');
    }

    public postureCriteriaBadgeClass(coverage: any): string {
        if (coverage === 'core') return 'bg-emerald-100 text-emerald-700';
        if (coverage === 'advisory') return 'bg-violet-100 text-violet-700';
        return 'bg-amber-100 text-amber-800';
    }

    public formatDetailValue(row: any): string {
        if (row?.format === 'ratio_percent') return this.formatRatioPercent(row?.value);
        if (row?.value === null || row?.value === undefined || row?.value === '') return '—';
        return String(row.value);
    }

    public formatAccuracy(value: any): string {
        if (value === null || value === undefined || value === '') return '—';
        const number = Number(value);
        if (!Number.isFinite(number)) return '—';
        const percentage = Math.abs(number) <= 1 ? number * 100 : number;
        return `${percentage.toFixed(1)}%`;
    }

    public formatResearchAccuracy(value: any): string {
        if (value === null || value === undefined || value === '') return '—';
        const number = Number(value);
        if (!Number.isFinite(number)) return '—';
        const percentage = Math.abs(number) <= 1 ? number * 100 : number;
        return `${percentage.toFixed(2)}%`;
    }

    public formatLoss(value: any): string {
        if (value === null || value === undefined || value === '') return '—';
        const number = Number(value);
        if (!Number.isFinite(number)) return '—';
        return number.toFixed(4);
    }

    public modelIcon(modelKey: string): string {
        if (modelKey === 'pose') return 'fa-person-rays';
        if (modelKey === 'bucky') return 'fa-vector-square';
        return 'fa-diagram-project';
    }

    public nativeVersionLabel(value: any): string {
        const version = String(value || '').trim();
        if (
            version === 'bucky-frame8-v3'
            || version.startsWith('bucky-ft-')
        ) {
            return `Bucky Frame 8-point incremental (${version}) · 외곽 8점과 중앙 보조 위치`;
        }
        const labels: any = {
            'rtmpose-m': 'RTMPose-m',
            mmpose: 'MMPose',
            'mediapipe-solutions': 'MediaPipe Solutions',
            'mediapipe-pose-landmarker': 'MediaPipe Pose Landmarker',
            'bucky-keypoints-v1': 'Bucky Keypoints v1',
            'bucky-keypoints-v2': 'Bucky Keypoints v2 (네 꼭짓점 + 변 중앙점 보간 + 중앙 보조)',
            'pose-bucky-composite-v1': 'Pose·Bucky Composite v1',
            inception_v3: 'InceptionV3',
            inceptionv3: 'InceptionV3',
            resnet50: 'ResNet50',
            densenet201: 'DenseNet201',
            efficientnet_b0: 'EfficientNetB0',
            vgg19: 'VGG19',
            xception: 'Xception',
            none: '통계 규칙'
        };
        return labels[value] || value || '—';
    }

    public poseLabel(value: any): string {
        const labels: any = {
            mmpose: 'MMPose',
            mmpose_rtmpose_m: 'MMPose (RTMPose-m, 이전 기록)',
            rtmpose_m: 'MMPose (RTMPose-m)',
            mediapipe: 'MediaPipe (이전 기록)',
            alphapose: 'AlphaPose',
            alphapose_yolov3: 'AlphaPose (YOLOv3 detector)',
            alphapose_yolox: 'AlphaPose (YOLOX detector)'
        };
        return labels[value] || value || '—';
    }

    public researchConfusionMatrix(model: any): string {
        const matrix = model?.runtime?.artifact?.metrics?.development?.confusion_matrix;
        if (!Array.isArray(matrix) || matrix.length !== 2
            || !Array.isArray(matrix[0]) || !Array.isArray(matrix[1])) {
            return '—';
        }
        return `정상 ${matrix[0][0]} / 오분류 ${matrix[0][1]} · 비정상 ${matrix[1][1]} / 오분류 ${matrix[1][0]}`;
    }

    public classifierLabel(value: any): string {
        return this.nativeVersionLabel(value);
    }

    public experimentStatusLabel(value: any): string {
        const labels: any = {
            baseline: '기준선',
            requested: '요청됨',
            running: '진행 중',
            completed: '완료',
            failed: '실패'
        };
        return labels[value] || value || '상태 없음';
    }

    public statusBadgeClass(value: any): string {
        if (value === 'completed') return 'bg-emerald-50 text-emerald-700';
        if (value === 'failed') return 'bg-red-50 text-red-700';
        if (value === 'running' || value === 'requested') return 'bg-sky-50 text-sky-700';
        if (value === 'baseline') return 'bg-amber-50 text-amber-800';
        return 'bg-slate-100 text-slate-600';
    }

    public researchStatusLabel(value: any): string {
        const labels: any = {
            ready: '연구 기능 준비됨',
            unavailable: '연구 기능 사용 불가',
            available: '실험 설정 가능',
            requested: '실행 요청됨',
            running: '실험 진행 중',
            validated: '내부 검증 완료',
            completed: '실험 완료',
            failed: '실험 실패'
        };
        return labels[value] || value || '내부 검증 전';
    }

    public researchStatusBadgeClass(value: any): string {
        if (value === 'ready' || value === 'validated' || value === 'completed') {
            return 'bg-emerald-100 text-emerald-700';
        }
        if (value === 'failed' || value === 'unavailable') return 'bg-red-100 text-red-700';
        if (value === 'requested' || value === 'running') {
            return 'bg-sky-100 text-sky-700';
        }
        return 'bg-amber-100 text-amber-800';
    }

    public referenceStatusLabel(item: any): string {
        if (!item?.valid) return '손상';
        if (item?.is_current) return '현재 기준';
        return '백업';
    }

    public referenceBadgeClass(item: any): string {
        if (!item?.valid) return 'bg-red-50 text-red-700';
        if (item?.is_current) return 'bg-emerald-50 text-emerald-700';
        return 'bg-slate-100 text-slate-600';
    }

    public datasetTotal(item: any): number {
        const snapshot = item?.dataset_snapshot || {};
        const counts = snapshot.counts || {};
        return Number(snapshot.total || (Number(counts.normal || 0) + Number(counts.abnormal || 0)) || 0);
    }

    public deploymentRecorded(item: any): boolean {
        return item?.deployment?.status === 'recorded';
    }

    public releaseCount(model: any): number {
        return (model?.history || []).filter((item: any) => item?.kind === 'release').length;
    }

    public retrainingStatusLabel(status: any): string {
        const labels: any = {
            awaiting_review: '재검토 승인 대기',
            awaiting_approval: '검증 완료 · 수동 승인 대기',
            accumulating: '자동 학습 데이터 누적',
            queued: '처리 대기',
            promotion_queued: '승격 처리 대기',
            retry_wait: '자동 재시도 대기',
            running: '처리 중',
            validating: '후보 검증 중',
            promoting: '서비스 반영 중',
            promoted: '운영 반영 완료',
            completed: '처리 완료',
            rejected: '검증 미통과 · 기존 모델 유지',
            failed: '처리 실패',
            superseded: '최신 수정으로 대체',
            cancelled: '처리 취소',
            unknown: '상태 확인 필요'
        };
        return labels[status] || (status ? '상태 확인 필요' : '처리 이력 없음');
    }

    public retrainingBadgeClass(status: any): string {
        if (status === 'promoted' || status === 'completed') {
            return 'bg-emerald-50 text-emerald-700';
        }
        if (status === 'rejected' || status === 'failed') {
            return 'bg-red-50 text-red-700';
        }
        if (
            status === 'awaiting_review'
            || status === 'awaiting_approval'
            || status === 'accumulating'
        ) return 'bg-amber-50 text-amber-800';
        if (
            status === 'queued'
            || status === 'promotion_queued'
            || status === 'retry_wait'
            || status === 'running'
            || status === 'validating'
            || status === 'promoting'
        ) return 'bg-sky-50 text-sky-700';
        return 'bg-slate-100 text-slate-600';
    }

    public trackByModel(index: number, model: any): string {
        return model?.key || String(index);
    }

    public trackByHistory(index: number, item: any): string {
        return item?.id || String(index);
    }

    public trackByTimeline(index: number, item: any): string {
        return `${item?.kind || 'item'}:${item?.id || index}`;
    }

    public trackByValidationItem(index: number, item: any): string {
        return item?.key || String(index);
    }

    private buckyPointLabel(value: any): string {
        const labels: any = {
            top_left: '좌상단',
            top_mid: '상단 중앙',
            top_right: '우상단',
            left_mid: '좌측 중앙',
            right_mid: '우측 중앙',
            bottom_left: '좌하단',
            bottom_mid: '하단 중앙',
            bottom_right: '우하단',
            center_cross: '중앙 보조점',
            corner_error: '외곽점 평균 오차',
            center_error: '중앙 보조점 오차',
            normal_holdout: '정상 자세 holdout 오차',
            normal_holdout_pck: '정상 자세 holdout PCK'
        };
        return labels[value] || String(value || '비교 항목');
    }

    private comparisonRow(
        key: string,
        fallbackLabel: string,
        value: any,
        direction: 'lower' | 'higher'
    ): any {
        const before = value?.before ?? value?.active;
        const after = value?.after ?? value?.candidate;
        const explicit = value?.passed
            ?? value?.improved
            ?? value?.non_regression;
        return {
            key,
            label: value?.label || value?.metric || fallbackLabel,
            before,
            after,
            passed: explicit === undefined
                ? this.nonRegression(before, after, direction)
                : explicit === true,
            direction
        };
    }

    private nonRegression(
        beforeValue: any,
        afterValue: any,
        direction: 'lower' | 'higher'
    ): boolean {
        const before = Number(beforeValue);
        const after = Number(afterValue);
        if (!Number.isFinite(before) || !Number.isFinite(after)) return false;
        return direction === 'higher' ? after >= before : after <= before;
    }

    private applyPayload(data: any) {
        data = this.publicDetectorTerminology(data);
        if (data?.operating_training_evidence?.reviewed_count) {
            this.operatingTrainingEvidence = data.operating_training_evidence;
        }
        const selectedKey = this.selectedModel?.key;
        const selectedApprovalId = this.selectedApprovalJob?.id;
        this.state = {
            reference: data?.reference || { current: {}, backups: [], core_features: [] },
            posture_criteria: data?.posture_criteria?.alignment === 'four_class_contract'
                ? data.posture_criteria
                : FOUR_POSTURE_CRITERIA,
            posture_classifier: data?.posture_classifier || {
                ready: true,
                mode: 'normalized_rule_baseline',
                image_classifier: { ready: false, training_image_count: 0 }
            },
            posture_operating_selection: data?.posture_operating_selection || {
                selected_id: 'legacy', selected_mode: 'legacy', choices: [], can_rollback: false
            },
            release: data?.release || {
                current_version: 0,
                current_label: null,
                next_version: 1,
                all_models_ready: false,
                history: []
            },
            models: this.normalizeOperatingModels(data?.models || []),
            tested_models: data?.tested_models || { pose: [], bucky: [] },
            research_models: data?.research_models || [],
            experiments: data?.experiments || [],
            latest_classifier: data?.latest_classifier || null,
            timeline: data?.timeline || [],
            retraining: data?.retraining || {
                active_count: 0,
                processing_count: 0,
                counts: {},
                by_model: {},
                jobs: []
            }
        };
        this.postureSelectionDraft = this.state.posture_operating_selection.selected_id || 'legacy';
        this.operatingLoading = false;
        this.rememberOperatingSnapshot();
        if (selectedKey) {
            this.selectedModel = this.models.find((model: any) => model?.key === selectedKey) || null;
            if (!this.selectedModel) this.restoreBodyScroll();
        }
        if (selectedApprovalId) {
            this.selectedApprovalJob = this.awaitingApprovalJobs.find(
                (job: any) => job?.id === selectedApprovalId
            ) || null;
            if (!this.selectedApprovalJob && !this.selectedModel) {
                this.restoreBodyScroll();
            }
        }
    }

    private applyOperatingPayload(data: any) {
        data = this.publicDetectorTerminology(data);
        if (data?.operating_training_evidence?.reviewed_count) {
            this.operatingTrainingEvidence = data.operating_training_evidence;
        }
        const models = Array.isArray(data?.models)
            ? this.normalizeOperatingModels(data.models).filter(
                (item: any) => ['pose', 'bucky', 'integrated'].includes(item?.key)
            )
            : [];
        if (!models.length) return;
        if (data?.reference?.current) {
            this.state.reference = {
                ...(this.state?.reference || {}),
                ...data.reference,
                current: {
                    ...(this.state?.reference?.current || {}),
                    ...data.reference.current
                }
            };
        }
        if (data?.posture_criteria?.alignment === 'four_class_contract') {
            this.state.posture_criteria = data.posture_criteria;
        }
        this.state.release = {
            ...(this.state?.release || {}),
            ...(data?.release || {})
        };
        this.state.models = models;
        this.rememberOperatingSnapshot();
    }

    private restoreOperatingSnapshot() {
        if (typeof window === 'undefined') return;
        try {
            const raw = window.sessionStorage.getItem(this.operatingSnapshotKey);
            const snapshot = raw ? JSON.parse(raw) : null;
            if (snapshot?.operating_training_evidence?.reviewed_count) {
                this.operatingTrainingEvidence = snapshot.operating_training_evidence;
            }
            if (snapshot?.reference?.current) {
                this.state.reference = snapshot.reference;
            }
            if (snapshot?.posture_criteria?.alignment === 'four_class_contract') {
                this.state.posture_criteria = snapshot.posture_criteria;
            }
            const models = Array.isArray(snapshot?.models)
                ? this.normalizeOperatingModels(snapshot.models).filter(
                    (item: any) => ['pose', 'bucky', 'integrated'].includes(item?.key)
                )
                : [];
            if (!models.length) return;
            this.state.release = {
                ...(this.state?.release || {}),
                ...(snapshot?.release || {})
            };
            this.state.models = models;
            this.operatingLoading = false;
        } catch (_) { }
    }

    private rememberOperatingSnapshot() {
        if (typeof window === 'undefined') return;
        const models = this.operatingModels;
        if (!models.length) return;
        try {
            window.sessionStorage.setItem(this.operatingSnapshotKey, JSON.stringify({
                operating_training_evidence: this.operatingTrainingEvidence,
                reference: this.state?.reference,
                posture_criteria: this.state?.posture_criteria,
                release: {
                    current_version: this.release?.current_version,
                    current_label: this.release?.current_label,
                    next_version: this.release?.next_version,
                    all_models_ready: this.release?.all_models_ready
                },
                models: models.map((model: any) => ({
                    key: model?.key,
                    name: model?.name,
                    short_name: model?.short_name,
                    description: model?.description,
                    operating: model?.operating,
                    release_version: model?.release_version,
                    release_label: model?.release_label,
                    updated_at: model?.updated_at,
                    native_version: model?.native_version,
                    performance: model?.performance,
                    performance_label: model?.performance_label,
                    performance_basis: model?.performance_basis,
                    metric_state: model?.metric_state,
                    sample_count: model?.sample_count,
                    reference_sample_count: model?.reference_sample_count,
                    training_sample_count: model?.training_sample_count,
                    validation_sample_count: model?.validation_sample_count,
                    test_sample_count: model?.test_sample_count,
                    coordinate_corrected_count: model?.coordinate_corrected_count,
                    data_scope: model?.data_scope,
                    data_scope_label: model?.data_scope_label,
                    model_architecture: model?.model_architecture,
                    reference_native_version: model?.reference_native_version,
                    summary: model?.summary,
                    limitations: model?.limitations || [],
                    detail_rows: model?.detail_rows || [],
                    history: (model?.history || []).filter(
                        (item: any) => item?.kind === 'release'
                    ).slice(0, 9)
                }))
            }));
        } catch (_) { }
    }

    private normalizeOperatingModels(source: any[]): any[] {
        if (!Array.isArray(source)) return [];
        const evidence = this.operatingTrainingEvidence || {};
        const reviewedCount = Number(evidence?.reviewed_count || 0);
        if (!reviewedCount) return source;
        const splits = evidence?.split_counts || {};
        return source.map((model: any) => {
            if (!['pose', 'bucky', 'integrated'].includes(model?.key)) return model;
            const modelEvidence = evidence?.models?.[model.key] || {};
            return {
                ...model,
                reference_sample_count: model?.reference_sample_count ?? model?.sample_count ?? 0,
                reference_native_version: model?.reference_native_version ?? model?.native_version,
                sample_count: reviewedCount,
                training_sample_count: Number(splits?.train || 0),
                validation_sample_count: Number(splits?.validation || 0),
                test_sample_count: Number(splits?.test || 0),
                coordinate_corrected_count: Number(evidence?.coordinate_corrected_count || 0),
                data_scope: 'reviewed_training_corpus',
                data_scope_label: evidence?.source_label || '검수 완료 라벨',
                native_version: modelEvidence?.model_id || model?.native_version,
                model_architecture: modelEvidence?.architecture || model?.model_architecture,
                artifact_sha256: modelEvidence?.sha256 || model?.artifact_sha256,
                updated_at: evidence?.activated_at || model?.updated_at
            };
        });
    }

    private showNotice(message: string) {
        this.notice = this.publicDetectorTerminology(message);
        if (this.noticeTimer) clearTimeout(this.noticeTimer);
        this.noticeTimer = setTimeout(async () => {
            if (this.destroyed) return;
            this.notice = '';
            await this.service.render();
        }, 5000);
    }

    private callError(error: any, fallback: string): string {
        return this.publicDetectorTerminology(
            error?.data?.message
            || error?.error?.message
            || error?.message
            || fallback
        );
    }

    private publicDetectorTerminology(value: any): any {
        if (typeof value === 'string') {
            return value
                .replace(/흉부\s*버키/g, '디텍터')
                .replace(/비버키/g, '디텍터가 없는')
                .replace(/버키/g, '디텍터')
                .replace(/\bDetector\b/g, '디텍터');
        }
        if (Array.isArray(value)) {
            return value.map((item: any) => this.publicDetectorTerminology(item));
        }
        if (value && typeof value === 'object') {
            return Object.keys(value).reduce((result: any, key: string) => {
                result[key] = this.publicDetectorTerminology(value[key]);
                return result;
            }, {});
        }
        return value;
    }

    private clearStatusTimer() {
        if (this.statusTimer) clearTimeout(this.statusTimer);
        this.statusTimer = null;
    }

    private lockBodyScroll() {
        if (
            typeof document === 'undefined'
            || this.originalBodyOverflow !== null
        ) return;
        this.originalBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }

    private restoreBodyScroll() {
        if (this.originalBodyOverflow === null || typeof document === 'undefined') return;
        document.body.style.overflow = this.originalBodyOverflow;
        this.originalBodyOverflow = null;
    }

    private pauseStatusRefresh() {
        this.clearStatusTimer();
        this.statusRequestGeneration += 1;
        this.loading = false;
        this.refreshing = false;
        this.statusErrorActive = false;
    }

    private shouldContinueStatusPolling(): boolean {
        return this.hasActiveRetraining();
    }

    private scheduleStatusRefresh(
        force: boolean = false,
        delay: number = 4000
    ) {
        this.clearStatusTimer();
        if (
            this.destroyed
            || (!force && !this.shouldContinueStatusPolling())
        ) return;
        this.statusTimer = setTimeout(() => {
            this.statusTimer = null;
            if (this.destroyed) return;
            void this.loadStatus(true);
        }, delay);
    }
}

export default PageXrayModelsComponent;